exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n      -ms-flex: auto;\n          flex: auto; }\n\n.container {\n  width: 100%;\n  background: #204F70; }\n\n.content {\n  width: 100%;\n  max-width: 800px;\n  margin: 0 auto;\n  color: white;\n  padding: 2rem 0; }\n\n.logo {\n  margin: .6rem;\n  font-size: 3rem;\n  color: white;\n  text-align: left;\n  text-shadow: 0 0.2rem rgba(0, 0, 0, 0.4); }\n\n.content-box {\n  padding: .6rem; }\n\na, span {\n  color: white;\n  text-align: right; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Thomas/Projekte/palettes/src/app/ui/footer/footer.component.scss
// module id = ../../../../../src/app/ui/footer/footer.component.scss
// module chunks = main